import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '姓名'
  }, {
    componentType: 'el-select',
    componentName: '下拉选择',
    fieldKey: 'sex',
    fieldName: '性别',
    url: 'Sex',
    selectType: 1,
    option: [],
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'defaultValue',
    fieldName: '是否默认联系人',
    width: 150
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'email',
    fieldName: '邮箱'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'phone',
    fieldName: '联系电话'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'post',
    fieldName: '岗位',
    width: 100
  }, {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'dept',
    fieldName: '部门',
    width: 100
  }, {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'address',
    fieldName: '省市县'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'addressDetail',
    fieldName: '详细地址'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'mark',
    fieldName: '备注'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'marketFlag',
    fieldName: '市场人员',
    convert: context => {
      const { rowData } = context
      return rowData.marketFlag ? '是' : '否'
    }
  },
  // {
  //   componentType: 'el-select',
  //   componentName: '输入框',
  //   fieldKey: 'taxIncluded',
  //   fieldName: '税前/税后',
  //   url: 'TaxType',
  //   selectType: 1,
  //   option: []
  // },
  {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'rate',
    fieldName: '比例'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'salesMan',
    fieldName: '业务员'
  }
]
